import MasterLayout from "@/layouts/master";
export default [
	{
    path: "/aportes",
    component: MasterLayout,
    children: [
      {
        path: "registrar",
        name: "aportes.registrar",
        component: () => import("@/views/aportes/registrar/index.vue")
      },
      {
        path: "descargar",
        name: "aportes.descargar",
        component: () => import("@/views/aportes/descargar/index.vue")
      },
      {
        path: "registros",
        name: "aportes.registros",
        component: () => import("@/views/aportes/registros/index.vue")
      },
      {
        path: "cuentas",
        name: "aportes.cuentas",
        component: () => import("@/views/aportes/cuentas/index.vue")
      },
      {
        path: "pendientes",
        name: "aportes.pendientes",
        component: () => import("@/views/aportes/pendientes/index.vue")
      },
    ]
  }
]